/**
 * @ngInject
 */

function momentize () {
    function link (scope, elem, attrs) {
        moment.locale(currentLang);
        // console.log("momentize", moment(attrs.momentize.toString(), attrs.momentizeParse));
        function onUpdate(){
            elem.text(moment(attrs.momentize.toString(), attrs.momentizeParse).format(attrs.momentizeDisplay));
        }
        attrs.$observe('momentize', onUpdate);
        attrs.$observe('momentizeDisplay', onUpdate);
    }

    return {
        restrict : 'A',
        link : link
    };
}